import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqItems = [{
  question: "What is included in the initial website application process?",
  answer: "Our application process is designed to understand your kennel's unique legacy (you and your breed), puppy and litter adoption processes, and brand/digital goals to ensure a Custom Website fit for our elite services."
}, {
  question: "How long does it take to see a draft of my new website?",
  answer: "Once your application is approved and the discovery phase is complete, you can expect a high-fidelity digital blueprint within 10 to 14 business days."
}, {
  question: "Can you integrate my existing health testing and pedigree data?",
  answer: "Absolutely. We specialize OFA updates, DNA results, and multi-generation pedigrees to ensure your digital home is as informative as it is beautiful."
}, {
  question: "Do you offer ongoing management for social media and updates?",
  answer: "Yes, our Social Concierge service provides scheduled content updates and just-in-time updates on achievements and litter updates, allowing you to focus entirely on your breeding program."
}, {
  question: "What makes PupzStudio different from a standard web agency?",
  answer: "We combine a deep passion for purebred dog breeding with world-class digital expertise, creating a concierge experience that understands the specific needs of breeders and the families they are targeting for their puppies and breed."
}, {
  question: "Why do you charge monthly?",
  answer: "Our monthly concierge model ensures your digital presence remains as dynamic as your breeding program. We provide priority litter updates, continuous SEO refinement, and ongoing technical support to maintain your status as a premier kennel."
}];
export default function OnboardingFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}